import { Route, Routes } from 'react-router-dom';

import VendorPortalList from '../components/VendorPortal/VendorPortalList';
import ViewVendorPortal from '../components/VendorPortal/ViewVendorPortal';

const VendorPortal = () => {

  return (
    <Routes>
      <Route path="/" element={<VendorPortalList />} />
      <Route path="/view/:id" element={<ViewVendorPortal />} />
    </Routes>
  );
}

export default VendorPortal;
